import type { FC } from 'react';
import { lazy } from 'react';

import { type RouteComponentProps } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { useAppRoutes } from '@webapp/hooks/useAppRoutes'
import messages from './messages'

const NetsuiteDetailsViewChunk = lazy(() =>
  import('../containers/NetsuiteDetailsView').then(
    ({ NetsuiteDetailsView }) => ({
      default: NetsuiteDetailsView,
    })
  )
)

export interface INetSuitePageProps extends RouteComponentProps<{}> {}

export const NetsuitePage: FC<INetSuitePageProps> = () => {
  const { url } = useAppRoutes()
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.netsuiteSetupPageTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsPageTitle),
        },
        {
          link: url('IntegrationsPage'),
          name: intl.formatMessage(messages.integrationsListTitle),
        },
        {
          name: intl.formatMessage(messages.netsuiteSetupPageTitle),
        },
      ]}
    >
      <NetsuiteDetailsViewChunk />
    </Page>
  )
}
